<template>
    <div style="margin-top: 100px; margin-bottom: 100px">
        <v-overlay :absolute="true" :value="submitting">
            <v-progress-circular indeterminate color="primary" class="mr-5"></v-progress-circular>
            <span>Processing Payment. Please wait...</span>
        </v-overlay>
        <div
            class="container-bg"
            dark
            style="background-color: transparent; margin-top: 5% !important; width: 45%; margin: auto"
        >
            <div class="container-bg">
                <div style="display: flex; flex-direction: row">
                    <img style="width: 130px; margin-bottom: 1%" src="../../assets/logos/getac-logo.svg" />
                    <div class="text-h7 nav-font pl-3" style="margin-top: 1.3%">PAY QUOTE</div>
                </div>
                <v-divider style="margin-bottom: 1%; border-color: gray" />
                <div style="display: flex; flex-direction: row">
                    <div style="display: block; margin: auto">
                        <div v-if="responseCode === '1' && submitting">
                            <p
                                class="text-h7 nav-font text-center"
                                style="display: block; margin: auto; margin-top: 25%"
                                >RMA {{ rmaId }}</p
                            >
                            <h1
                                style="font-size: 36px; letter-spacing: -0.08rem; margin-bottom: 10%"
                                class="text-center"
                                >Processing Payment</h1
                            >
                        </div>
                        <div v-else-if="responseCode === '1'">
                            <p class="text-h7 nav-font text-center" style="display: block">RMA {{ rmaId }}</p>
                            <h1 style="font-size: 36px; letter-spacing: -0.08rem" class="text-center"
                                >Paid Successfully!</h1
                            >
                            <download-label
                                :key="newRmaResponse.rmaNumber"
                                :user-input="rmaInput"
                                :international="international"
                                :create-rma-response="newRmaResponse"
                                @downloadLabel="downloadLabel"
                            />
                        </div>
                        <div v-else>
                            <h1
                                style="font-size: 36px; letter-spacing: -0.08rem; margin-bottom: 10%"
                                class="text-center"
                                >Failed to Pay the RMA {{ rmaId }}</h1
                            >
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
        <v-snackbar v-model="snackbar" color="error">
            {{ snackbarMessage }}

            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" color="white" @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import { processOowRma } from '@/api'
import DownloadLabel from '@/components/create_rma_stepper/steps/download_label.vue'

export default {
    name: 'RMAAuthNetPaymentResponse',
    components: {
        DownloadLabel
    },
    data() {
        return {
            responseCode: this.$route.params.responseCode || this.$route.query.responseCode,
            transId: this.$route.params.transId || this.$route.query.transId,
            quoteId: this.$route.params.quoteId || this.$route.query.quoteId,
            method: this.$route.params.method || this.$route.query.method,
            rmaId: this.$route.params.rmaId || this.$route.query.rmaId,
            responseReason: this.$route.params.responseReason || this.$route.query.responseReason,
            snackbar: false,
            snackbarMessage: '',
            submitting: true,
            quoteDetail: null,
            newRmaResponse: {
                rmaNumber: ``
            },
            quoteData: {},
            rmaInput: {}
        }
    },
    async mounted() {
        this.submitting = true

        if (this.responseCode === '1') {
            await this.confirmPayment()
            if (this.quoteDetail) {
                await this.approveOowRmaAuthorizeNet()
                await this.getRMAData(this.rmaId)
            }
        } else {
            // load old form
            this.quoteData = await this.getQuoteData(this.quoteId)
            if (this.quoteData) this.loadRma()
        }
        this.submitting = false
    },
    methods: {
        showMessage(message) {
            this.snackbar = true
            this.snackbarMessage = message
        },
        downloadLabel(url) {
            window.open(url)
        },
        international() {
            return this.addressData.country && this.addressData.country !== `US`
        },
        loadRma() {
            const routeName = 'create-rma'
            const toPage = routeName.includes('upgrade') ? 5 : 4
            this.$router.push({
                name: routeName,
                params: {
                    serial: this.quoteData.externalResource.serial,
                    toPage,
                    quoteData: this.quoteData,
                    paymentError: `Payment Failed: ${this.responseReason}`
                }
            })
        },
        async getQuoteData(quoteId) {
            const dataRec = await this.$apollo.query({
                query: gql`
                    query GetSingleQuote($uid: String!) {
                        getSingleQuote(uid: $uid) {
                            uid
                            customerSaved
                            service
                            reference
                            externalResource
                            shipping {
                                address {
                                    line1
                                    line2
                                    city
                                    state
                                    country
                                    postalCode
                                    international
                                    apo
                                }
                                contact {
                                    emailAddress
                                    phoneNumber
                                    firstName
                                    lastName
                                    companyName
                                    fullName
                                }
                            }
                            total
                        }
                    }
                `,
                variables: {
                    uid: quoteId
                }
            })
            if (dataRec && dataRec.data && dataRec.data.getSingleQuote) {
                return dataRec.data.getSingleQuote
            }
            return null
        },
        async getRMAData(rmaId) {
            const dataRec = await this.$apollo.query({
                query: gql`
                    query RMA($rmaNumber: String!) {
                        RMA(rmaNumber: $rmaNumber) {
                            uid
                            rmaType
                            primaryFault
                            problem
                            additionalProblems
                            paymentMethod
                            initialNotes
                            assetTag
                            status
                            tpm
                            rmaLive
                            customerStatus
                            customer {
                                customerId
                                shipping {
                                    address {
                                        APO
                                        company
                                        line1
                                        line2
                                        city
                                        state
                                        country
                                        postalCode
                                        international
                                    }
                                    contact {
                                        firstName
                                        lastName
                                        email
                                        phone
                                        company
                                        fullName
                                        position
                                    }
                                }
                            }
                            packaging {
                                havePackaging
                                requestBox
                            }
                            permissions {
                                reimage
                                biosFirmware
                                userId
                                userPassword
                                biosPassword
                            }
                            acc {
                                acPower
                                hardCase
                                battery
                                storage
                            }
                            customerReference
                            unit {
                                serial
                                model
                                warrantyType
                                endDeviceWarranty
                            }
                        }
                    }
                `,
                variables: {
                    rmaNumber: rmaId
                }
            })
            if (dataRec && dataRec.data && dataRec.data.RMA) {
                const rmaData = dataRec.data.RMA
                this.rmaInput.problemData = {
                    primaryFault: rmaData.primaryFault,
                    problem: rmaData.problem,
                    additionalProblems: rmaData.additionalProblems,
                    initialNotes: rmaData.initialNotes,
                    permissions: rmaData.permissions,
                    acc: rmaData.acc,
                    custReference: rmaData.customerReference,
                    assetTag: rmaData.assetTag
                }
                this.rmaInput.contactData = {
                    ...rmaData.customer.shipping.contact
                }
                this.rmaInput.addressData = {
                    ...rmaData.customer.shipping.address
                }
                this.rmaInput.packingData = {
                    ...rmaData.packaging
                }
                this.rmaInput.unitData = {
                    ...rmaData.unit
                }
            }
        },
        async approveOowRmaAuthorizeNet() {
            this.overlayProcessing = true
            processOowRma({
                rmaNumber: this.rmaId
            })
                .then(({ data }) => {
                    this.newRmaResponse = data
                    this.currentStep = this.steps.length
                })
                .catch((e) => {
                    if (e.data.rmaNumber && e.data.rmaNumber.length > 0) {
                        this.newRmaResponse = {
                            ...e.data,
                            shippingError: true
                        }
                        this.currentStep = this.steps.length
                    } else {
                        this.submissionError =
                            e.data && e.data.message && (`` + e.data.message).toLowerCase().includes('shipper')
                                ? `Error validating address, please verify your information and try again.`
                                : `Error Creating RMA: ${e.data.message}`
                        throw e
                    }
                    console.error(`API Error Creating RMA:` + e.data.message)
                })
                .finally(() => {
                    this.overlayProcessing = false
                })
        },

        async confirmPayment() {
            // check quote id
            if (this.responseCode !== '1' || !this.quoteId || !this.transId) return
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation ConfirmAuthNetPayment($transId: String!, $quoteId: String!) {
                            confirmAuthNetPayment(transId: $transId, quoteId: $quoteId) {
                                payment {
                                    uid
                                    source
                                    url
                                    status
                                    transaction
                                    adminStatus
                                }
                            }
                        }
                    `,
                    variables: {
                        quoteId: this.quoteId,
                        transId: this.transId
                    }
                })
                .catch((errors) => {
                    this.showMessage(errors)
                })
                .then(async (data) => {
                    this.quoteDetail = data.data.confirmAuthNetPayment
                    // await this.processRma()
                })
        }
    }
}
</script>
